import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { OrderFilters } from '@/data/models/order.interface';
import { Platform } from '@/data/models/platform.interface';
import { Tenant } from '@/data/models/tenant.interface';

export interface OrdersSelectionState {
  prefilledTenant: Tenant | null;
  prefilledFilters: OrderFilters | null;
  prefilledOrderPlatform: string | null;
  currentPlatform: Platform | null;
  currentTenant: Tenant | null;
  currentFilters: OrderFilters | null;
  currentOrderPlatform: string | null;

  setPrefilledTenant: (_tenant: Tenant | null) => void;
  setPrefilledFilters: (_filters: OrderFilters | null) => void;
  setPrefilledOrderPlatform: (_platform: string | null) => void;
  clearPrefilled: () => void;
  setCurrentSelection: (
    _platform: Platform | null,
    _tenant: Tenant | null,
    _filters: OrderFilters | null,
    _orderPlatform?: string | null,
  ) => void;
  clearCurrentSelection: () => void;
}

const useOrdersSelectionStore = create<OrdersSelectionState>()(
  devtools(
    (set) => ({
      prefilledTenant: null,
      prefilledFilters: null,
      prefilledOrderPlatform: null,
      currentPlatform: null,
      currentTenant: null,
      currentFilters: null,
      currentOrderPlatform: null,

      setPrefilledTenant: (tenant: Tenant | null) => {
        set({ prefilledTenant: tenant }, false, 'setPrefilledTenant');
      },

      setPrefilledFilters: (filters: OrderFilters | null) => {
        set({ prefilledFilters: filters }, false, 'setPrefilledFilters');
      },

      setPrefilledOrderPlatform: (platform: string | null) => {
        set(
          { prefilledOrderPlatform: platform },
          false,
          'setPrefilledOrderPlatform',
        );
      },

      clearPrefilled: () => {
        set(
          {
            prefilledTenant: null,
            prefilledFilters: null,
            prefilledOrderPlatform: null,
          },
          false,
          'clearPrefilled',
        );
      },

      setCurrentSelection: (
        platform: Platform | null,
        tenant: Tenant | null,
        filters: OrderFilters | null,
        orderPlatform?: string | null,
      ) => {
        set(
          {
            currentPlatform: platform,
            currentTenant: tenant,
            currentFilters: filters,
            currentOrderPlatform: orderPlatform ?? null,
          },
          false,
          'setCurrentSelection',
        );
      },

      clearCurrentSelection: () => {
        set(
          {
            currentPlatform: null,
            currentTenant: null,
            currentFilters: null,
            currentOrderPlatform: null,
          },
          false,
          'clearCurrentSelection',
        );
      },
    }),
    { name: 'OrdersSelectionStore' },
  ),
);

export default useOrdersSelectionStore;
